import React from 'react';
import { IntlProvider } from 'react-intl';
import messages_en from 'translations/en.json';
import messages_br from 'translations/br.json';
import messages_fr from 'translations/fr.json';
import messages_sp from 'translations/sp.json';
import store from 'states/store';
import {
  defaultRichTextElements,
} from './intlRichText';

const messages = {
  en: messages_en,
  br: messages_br,
  fr: messages_fr,
  sp: messages_sp,
};

const languageBrowser = navigator.language?.split(/[-_]/)[0] || 'en';

// Function to get current language from store
export const getCurrentLanguage = () => {
  const state = store.getState();
  const languageLo = state.common?.lang;
  return languageLo || languageBrowser;
};

// HOC to wrap modal content with IntlProvider
export const withIntlProvider = (Component) => {
  return (props) => {
    const language = getCurrentLanguage();
    return (
      <IntlProvider
        locale={language}
        messages={messages[language]}
        defaultRichTextElements={defaultRichTextElements}
      >
        <Component {...props} />
      </IntlProvider>
    );
  };
};
